import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <motion.div
    className={`overflow-hidden ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-40px" }}
  >
    <motion.div
      className={innerClassName}
      variants={{ hidden: { y: "112%" }, show: { y: "0%" } }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  </motion.div>
);

export const SectionLabel = ({ index, title }) => (
  <div className="flex items-center gap-4" data-testid={`section-label-${title.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className="font-display text-sm tracking-[0.3em] text-zinc-500">{index}</span>
    <span className="h-px w-10 bg-zinc-700" />
    <span className="text-xs uppercase tracking-[0.3em] text-zinc-500">{title}</span>
  </div>
);

export { EASE };
